import {Component, Input} from '@angular/core';
import {FieldDataDto} from '../../../../../Models/Tasks/General/task.interface';

@Component({
  selector: 'app-title-field',
  templateUrl: './title-field.component.html',
  styleUrls: ['./title-field.component.scss'],
  standalone: false
})
export class TitleFieldComponent {
  @Input() field!: FieldDataDto;
}
